module.exports = __webpack_public_path__ + "images/card-mastercard.70f1e6ae43b6cbf2418980d24d8addc8.svg";